module.exports = __webpack_public_path__ + "static/img/bjtp_jiazhiguanthree@2x.b4d5a70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/entry/bjtp_jiazhiguanthree@2x.png
// module id = p1z7
// module chunks = 0